<style scoped>
    @import url("../../styles/smartControl/aSmartControl.scss");
</style>

<template>
    <div class="box_aSC">

        <!-- Se estiver travando a entrada, colocar um loading com flag condicionado a 1a req rcv -->
        
        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <div class="titGeral" v-if="!flagMsgSistema">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-progress-wrench</v-icon>
            <span class="ml-2">Estado dos atuadores</span>
        </div>

        <div class="painelGeral" v-if="!flagMsgSistema">

            <!-- 16/12/2025 mdi-wrench-cog -->
            <EstadoAtu :execSys="$store.state.sistemaSC" />

        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-timer-cog-outline</v-icon>
            <span class="ml-2">Configurações de atuação</span>
        </div>

        <div class="painelGeral" v-if="!flagMsgSistema">
            <!--<Atuador :t="'Parâmetros de Operação Diária'" /> versão v0 -->
            
            <!-- 14/10/2025 -->
            <Atuador />
        </div>

    </div>
</template>

<script>
import Atuador from './Atuador'
import EstadoAtu from './subAtu/EstadoAtu'

export default {

    components:{Atuador, EstadoAtu},

    data() {
        return {
            //
            //r:'/dadoslipordia',
            //r3:'/lastreadingorange',

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.
        }
    },

    methods:{
        //
    },

    created() {
        window.scrollTo(0,0)

        // -- obter sistema atual selecionado.
        let execSys = this.$store.state.sistemaSC

        // -- se sistema vazio, então não buscar o sistema...
        if (execSys == '') { this.flagMsgSistema = true; return; } 
        else { this.flagMsgSistema = false }
    }
}
</script>